module.exports = __webpack_public_path__ + "static/media/1-_DSC8309.bd9f3779.jpg";